export default "__VITE_ASSET__BzyE732L__"